import { useTranslation } from 'react-i18next';

import {
	Box,
	DotsHorizontalOutline,
	Flex,
	IconButton,
	LinkAltOutline,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Portal,
	rem,
	TagOutline,
	Text,
	useDisclosure,
} from '@bonusly/design-system';

import { useActionInput } from '../../context';

export const CollapsedButtons = () => {
	const { t } = useTranslation('action_input');
	const { editor } = useActionInput();
	const { isOpen, onClose, onToggle } = useDisclosure();

	// Ideally we want to pass in any buttons to be collapsed and not duplicate the logic here
	// but currently we are only supporting moving link and mention buttons into the collapsed buttons
	const decorations = [
		{
			module: 'link' as const,
			label: t('decorations.add_a_link_tooltip'),
			onClick: () => {
				editor?.commands.insertLink();
				onClose();
			},
			icon: <LinkAltOutline />,
		},
		{
			module: 'mention' as const,
			label: t('decorations.tag_tooltip_short'),
			onClick: () => {
				editor?.chain().insertContent('&').focus().run();
				onClose();
			},
			icon: <TagOutline />,
		},
	];

	return (
		<Popover isLazy isOpen={isOpen} onClose={onClose} placement="top-start">
			<PopoverTrigger>
				<IconButton
					aria-label="More actions"
					icon={<DotsHorizontalOutline />}
					borderRadius={rem(10)}
					boxSize={rem(40)}
					color="info.text"
					fontSize={rem(24)}
					onClick={onToggle}
					_hover={{
						background: 'bg.canvas',
					}}
				/>
			</PopoverTrigger>

			<Portal>
				<PopoverContent width="fit-content">
					<Box p={1}>
						{decorations.map((dec) => (
							<Flex
								key={dec.module}
								onClick={dec.onClick}
								cursor="pointer"
								alignItems="center"
								p={3}
								width="100%"
								borderRadius="sm"
								transition="all 0.2s"
								_hover={{ bg: 'bg.canvas' }}
							>
								<Box fontSize={rem(24)} color="info.text" display="flex" alignItems="center">
									{dec.icon}
								</Box>
								<Text as="span" color="info.text" ml={2} fontSize="md" fontWeight="medium">
									{dec.label}
								</Text>
							</Flex>
						))}
					</Box>
				</PopoverContent>
			</Portal>
		</Popover>
	);
};
